"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var uuid_1 = (0, tslib_1.__importDefault)(require("../../shared-utils/uuid"));
var WeappBridgeMessage_1 = require("../typings/WeappBridgeMessage");
var WebSocketCloseOptions_1 = require("../typings/WebSocketCloseOptions");
var defaultWsEndpoint_1 = (0, tslib_1.__importDefault)(require("../utils/defaultWsEndpoint"));
var generateWssUrl_1 = (0, tslib_1.__importDefault)(require("../utils/generateWssUrl"));
var isValidKey_1 = (0, tslib_1.__importDefault)(require("../utils/isValidKey"));
var parseQuery_1 = (0, tslib_1.__importDefault)(require("../utils/parseQuery"));
var ws_1 = (0, tslib_1.__importDefault)(require("./ws"));
var ws = (function () { return new ws_1.default(); })();
var HybridBridge = /** @class */ (function () {
    function HybridBridge() {
        var _this = this;
        /**
         * @deprecated 兼容旧逻辑
         */
        this._rsWeappBridgeMethodAdapter = {};
        this._forceClose = false;
        /**
         * 进行jsbridge的初始化，即打通ws通道
         * @param timeout 超时计时
         * @returns
         */
        this.initialize = function (timeout) {
            if (timeout === void 0) { timeout = 6000; }
            return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
                var res, _a, wssid, wstsp, wssig, _b, wsmnt, url, result, _c, _d, e_1;
                return (0, tslib_1.__generator)(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            res = [false, null];
                            _a = (0, parseQuery_1.default)(globalThis.location.search), wssid = _a.wssid, wstsp = _a.wstsp, wssig = _a.wssig, _b = _a.wsmnt, wsmnt = _b === void 0 ? defaultWsEndpoint_1.default : _b;
                            if (!(wssid && wstsp && wssig && wsmnt)) {
                                res[1] = new Error('HybridBridge 参数缺失，初始化失败~');
                                return [2 /*return*/, res];
                            }
                            url = (0, generateWssUrl_1.default)('{{origin}}/{{endpoint}}/{{uuid}}/{{member}}/{{ak}}/{{ts}}/{{sign}}', {
                                origin: wsmnt,
                                endpoint: 'proxy',
                                uuid: wssid,
                                member: 'webview',
                                ak: 'vr_live_miniapp',
                                ts: wstsp,
                                sign: wssig,
                            });
                            _e.label = 1;
                        case 1:
                            _e.trys.push([1, 6, , 7]);
                            return [4 /*yield*/, ws.connect({ url: url })];
                        case 2:
                            result = _e.sent();
                            if (!result) return [3 /*break*/, 4];
                            this.initBuiltInHandlers();
                            _c = res;
                            _d = 0;
                            return [4 /*yield*/, this.waitReady(timeout)];
                        case 3:
                            _c[_d] = _e.sent();
                            return [3 /*break*/, 5];
                        case 4:
                            res[1] = new Error('HybridBridge ws未连接，初始化失败~');
                            _e.label = 5;
                        case 5: return [3 /*break*/, 7];
                        case 6:
                            e_1 = _e.sent();
                            res[1] = e_1;
                            return [3 /*break*/, 7];
                        case 7: return [2 /*return*/, res];
                    }
                });
            });
        };
        this.getStaticData = function (callbackFunctionName) {
            _this.callAndBackfeed(JSON.stringify({
                actionUrl: 'common/staticData',
                functionName: callbackFunctionName,
            }));
        };
        /**
         * 处理一次性执行的方法
         * @param msg JSON.stringify({ actionUrl: string, functionName: string })
         */
        this.callAndBackfeed = function (msg) {
            var _a = JSON.parse(msg), _b = _a.actionUrl, actionUrl = _b === void 0 ? '' : _b, _c = _a.functionName, functionName = _c === void 0 ? '' : _c;
            if (!actionUrl)
                throw new Error('callAndBackfeed actionUrl is empty!');
            if (!functionName)
                throw new Error('callAndBackfeed functionName is empty!');
            var callback = function (result) {
                if (typeof globalThis[functionName] === 'function') {
                    ;
                    globalThis[functionName](result);
                }
            };
            _this._callAndBackfeed(actionUrl, callback);
        };
        /**
         * 处理监听
         * @param msg JSON.stringify({ actionUrl: string, functionName: string })
         */
        this.callAndListen = function (msg) {
            var _a = JSON.parse(msg), actionUrl = _a.actionUrl, functionName = _a.functionName;
            if (!actionUrl)
                throw new Error('callAndListen actionUrl is empty!');
            if (!functionName)
                throw new Error('callAndListen functionName is empty!');
            var callback = function (result) {
                if (typeof globalThis[functionName] === 'function') {
                    ;
                    globalThis[functionName](result);
                }
            };
            try {
                _this._callAndListen(actionUrl, callback);
            }
            catch (e) {
                console.warn(e);
                callback(false);
            }
        };
    }
    /**
     * 内建的处理函数
     */
    HybridBridge.prototype.initBuiltInHandlers = function () {
        this._registerLifecycleHandler();
        this._registerHeartbeatHandler();
        this._registerMessageHandler();
        this._registerBridgeRequestHandler();
        this._registerReadyHandler();
    };
    /**
     * 注册生命周期回调
     */
    HybridBridge.prototype._registerLifecycleHandler = function () {
        var _this = this;
        ws.onOpen(function () { return console.log('RsWeappBridge open'); });
        ws.onClose(function (res) {
            console.log('RsWeappBridge close');
            if (res.code === 1000) {
                switch ((res.reason + '').toLowerCase()) {
                    case WebSocketCloseOptions_1.WebSocketCloseOptions.lostHeartbeat.reason: {
                        // 心跳丢失
                        ws.reconnect();
                        break;
                    }
                    // case WebSocketCloseOptions.normalClosure.reason: // 主动关闭
                    case WebSocketCloseOptions_1.WebSocketCloseOptions.interrupted.reason: // 切换到后台，被微信杀掉，需要重连连接
                    case WebSocketCloseOptions_1.WebSocketCloseOptions.streamEndEncountered.reason: // 服务端拒绝连接
                    default: {
                        if (!_this._forceClose) {
                            ws.reconnect();
                        }
                        break;
                    }
                }
            }
            if (res.code !== 1000 && !_this._forceClose) {
                ws.reconnect();
            }
            if (_this._forceClose)
                _this._forceClose = false;
        });
        ws.onError(function (err) { return console.error(err); });
    };
    /**
     * 注册心跳的回调
     * @deprecated 兼容老的容器SDK
     */
    HybridBridge.prototype._registerHeartbeatHandler = function () {
        // 收到ping时回复pong
        this._receivedMessage(WeappBridgeMessage_1.WeappBridgeMessage.ping, function () { return ws.send(WeappBridgeMessage_1.WeappBridgeMessage.pong); });
        // 收到pong时回复ping
        this._receivedMessage(WeappBridgeMessage_1.WeappBridgeMessage.pong, function () { return ws.send(WeappBridgeMessage_1.WeappBridgeMessage.ping); });
    };
    /**
     * 当收到某消息时
     * @param targetMessage 目标消息
     * @param handler 回调
     * @param once 是否一次性处理
     */
    HybridBridge.prototype._receivedMessage = function (targetMessage, handler, once) {
        var msgHandler = function (msg) {
            if (msg === targetMessage) {
                handler();
                if (once) {
                    ws.offMessage(msgHandler);
                }
            }
        };
        ws.onMessage(msgHandler);
    };
    /**
     * 强制关闭ws
     * @param options
     */
    HybridBridge.prototype.forceClose = function (options) {
        this._forceClose = true;
        ws.close(options);
    };
    /**
     * 注册准备就绪的回调
     */
    HybridBridge.prototype._registerReadyHandler = function () {
        // 收到就绪询问时回复已就绪
        this._receivedMessage(WeappBridgeMessage_1.WeappBridgeMessage.isReady, function () { return ws.send(WeappBridgeMessage_1.WeappBridgeMessage.ready); });
    };
    /**
     * 发送消息
     */
    HybridBridge.prototype.send = function (data) {
        ws.send(data);
    };
    /**
     * 等待响应
     * @param timeout 超时计时
     * @returns
     */
    HybridBridge.prototype.waitReady = function (timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = 6000; }
        return new Promise(function (resolve, reject) {
            _this._receivedMessage(WeappBridgeMessage_1.WeappBridgeMessage.ready, function () { return resolve(true); });
            _this.send(WeappBridgeMessage_1.WeappBridgeMessage.isReady);
            setTimeout(function () { return reject('HybridBridge 初始化超时~'); }, timeout);
        });
    };
    /**
     * 注册消息投递回调
     * @deprecated 兼容老方法
     */
    HybridBridge.prototype._registerMessageHandler = function () {
        var _this = this;
        ws.onMessage(function (message) {
            if (typeof message === 'object') {
                var id = message.id, command = message.command, data = message.data;
                if (command === 'message' && typeof _this._rsWeappBridgeMethodAdapter.bindMessage === 'function') {
                    _this._rsWeappBridgeMethodAdapter.bindMessage({ id: id, data: data });
                }
            }
        });
    };
    /**
     * 注册bridge方法回调
     * @deprecated 兼容老方法
     */
    HybridBridge.prototype._registerBridgeRequestHandler = function () {
        var _this = this;
        ws.onMessage(function (request) { return (0, tslib_1.__awaiter)(_this, void 0, void 0, function () {
            var id, method, args, command, result, error, _method, e_2;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof request === 'object')) return [3 /*break*/, 7];
                        id = request.id, method = request.method, args = request.args, command = request.command;
                        if (!(command === 'request')) return [3 /*break*/, 7];
                        if (!method) return [3 /*break*/, 7];
                        result = null;
                        error = null;
                        _method = null;
                        if (typeof this._rsWeappBridgeMethodAdapter[method] === 'function') {
                            // 优先读 _rsWeappBridgeMethodAdapter 上注册的方法
                            _method = this._rsWeappBridgeMethodAdapter[method];
                        }
                        else if (globalThis && (0, isValidKey_1.default)(method, globalThis)) {
                            // 再读 globalThis 下的方法
                            _method = globalThis[method];
                        }
                        if (!(typeof _method === 'function')) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, _method(args)];
                    case 2:
                        result = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        error = e_2.message || e_2;
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error = 'Method not implemented.';
                        _a.label = 6;
                    case 6:
                        this.send(JSON.stringify({ id: id, method: method, result: result, error: error, command: 'response' }));
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 处理 callAndBackfeed
     * @param actionUrl
     * @param backfeed
     */
    HybridBridge.prototype._callAndBackfeed = function (actionUrl, backfeed) {
        var reqId = (0, uuid_1.default)();
        var data = JSON.stringify({
            id: reqId,
            actionUrl: actionUrl,
            command: 'rsSchemeRequest',
            type: 'callAndBackfeed',
        });
        var timer = null;
        var callback = function (message) {
            var id = message.id, result = message.result, errmsg = message.errmsg, command = message.command;
            if (command === 'rsSchemeResponse' && id === reqId) {
                ws.offMessage(callback);
                if (timer)
                    clearTimeout(timer);
                if (errmsg) {
                    console.warn(errmsg);
                    backfeed(0);
                }
                else {
                    backfeed(result);
                }
            }
        };
        ws.onMessage(callback);
        this.send(data);
        // 30s超时处理
        timer = global.setTimeout(function () {
            console.warn('callAndBackfeed timeout');
            backfeed(0);
        }, 30000);
    };
    /**
     * 处理 _callAndListen
     * @param actionUrl
     * @param fn
     */
    HybridBridge.prototype._callAndListen = function (actionUrl, fn) {
        var reqId = (0, uuid_1.default)();
        var data = JSON.stringify({
            id: reqId,
            actionUrl: actionUrl,
            command: 'rsSchemeRequest',
            type: 'callAndListen',
        });
        var callback = function (message) {
            var id = message.id, result = message.result, errmsg = message.errmsg, command = message.command;
            if (command === 'rsSchemeResponse' && id === reqId) {
                if (errmsg) {
                    console.warn(errmsg);
                    fn(false);
                }
                else {
                    fn(result);
                }
            }
        };
        ws.onMessage(callback);
        this.send(data);
    };
    return HybridBridge;
}());
exports.default = HybridBridge;
//# sourceMappingURL=index.js.map